import { defineMessage } from '@lingui/core/macro';
import { UnitJsonConfig } from '@/core/types/battle.types';

export const druzhynnyk: UnitJsonConfig = {
    id: 'druzhynnyk',
    unitName: defineMessage({ message: 'Ratnyk' }),
    stats: {
        hp: 95,
        stamina: 110,
        speed: 4,
        armor: 30,
        evasion: 5,
        meleeSkill: 95,
        armorPenetration: 0.25,
        critChance: 10,
        critMult: 1.25,
        initiative: 30,
        damageMin: 12,
        damageMax: 16,
    },
    skills: [
        {
        id: 'r_s_thrust',
        name: defineMessage({ message: 'Spear Thrust' }),
        sort: 10,
        cost: 45,
        range: 2,
        powerMult: 1,
        hitChanceBonus: 5,
        iconRow: 3,
        iconCol: 0,
    },
    ],
    anchor: {
        x: 0.44,
        y: 0.66,
    },
    badge: {
        x: 70,
        y: -190,
    },
    unitPortrait: {
        row: 0,
        col: 2,
    },
} satisfies UnitJsonConfig;
